import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon, FileTextIcon, GlobeIcon, RefreshCwIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
const badges = [{
  Icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  Icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  Icon: CreditCardIcon,
  label: 'Tarjeta · Transferencia · PayPal'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: GlobeIcon,
  label: 'Todo Latinoamérica'
}];
export function FinalCta() {
  return <section className="bg-cream px-4 py-16" data-id="element-74" data-mp="1t4r8xag6rj1v">
      <div className="mx-auto max-w-md text-center" data-id="element-75" data-mp="1o4wit948ixhv">
        <p className="text-xs font-bold uppercase tracking-widest text-magenta" data-id="element-76" data-mp="1o67pphsz8ld7">
          ⏰ Último llamado
        </p>
        <div className="mt-4" data-id="element-77" data-mp="1x4ta7ii0eagm">
          <Countdown data-id="element-78" data-mp="1x5uorwy8hf33" />
        </div>

        <div className="mt-8 rounded-3xl border border-navy/10 bg-white p-6 shadow-soft" data-id="element-79" data-mp="1x2ozohplud7d">
          <h3 className="font-display text-xl font-black text-navy" data-id="element-80" data-mp="n7p6tg60bfku">
            📘 Método Domingo Libre
          </h3>
          <div className="mt-3" data-id="element-81" data-mp="x3s68e9h5043">
            <span className="font-display text-lg font-bold text-navy/40 line-through" data-id="element-82" data-mp="x3iofdyl1z9h">
              $97 USD
            </span>
            <div className="mt-1 font-display text-5xl font-black text-magenta" data-id="element-83" data-mp="124g51m3y2l8v">
              $12.99 <span className="text-2xl" data-id="element-84" data-mp="163oy0or5uf3d">USD</span>
            </div>
            <p className="mx-auto mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-teal/10 px-3 py-1.5 text-xs font-bold text-teal" data-id="element-85" data-mp="1b31k37a7ji4w">
              <RefreshCwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-86" data-mp="1fwcvzmtvmp3o" />
              Cambio de moneda automático según tu país.
            </p>
          </div>
          <div className="mt-6" data-id="element-87" data-mp="1pth7msq3j268">
            <CtaButton data-id="element-88" data-mp="1puagbz8m81r0" />
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-2.5 text-left" data-id="element-89" data-mp="1tt9mto9zw6kk">
          {badges.map(b => <div key={b.label} className="flex items-center gap-2 rounded-xl bg-white px-3 py-2.5 text-xs font-semibold text-navy/75 shadow-card" data-id="element-90" data-mp="3qtvzej24veiv">
              <b.Icon className="h-4 w-4 shrink-0 text-brandpurple" data-id="element-91" data-mp="3i4q8vx37guc" />
              <span data-id="element-92" data-mp="3jfusxycwsmi">{b.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}